<template>
    <div>
        <Navigator />
        <section class="mbr-section content4 cid-r5nGMjtCuA" id="content4-i">
            <section class="mbr-section article content9 cid-r5nGwN4mUE" id="content9-d">
            </section>
            
            <div class="container">
                <div class="media-container-row">
                    <Loading :active.sync="isLoading"></Loading>
                    <div class="title col-12 col-md-8">
                        <h2 class="align-center pb-3 mbr-fonts-style display-2">
                            {{article.title}}
                        </h2>
                        <h3 class="mbr-section-subtitle align-center mbr-light mbr-fonts-style display-7">
                            <div v-if="!isLoading">
                                <span class="fa fa-user"></span>&nbsp;<router-link :to="{name: 'searchByKeyword', params: {type: 'author', keyword: article.author, page: 1} }">{{article.author}}&nbsp;&nbsp;</router-link> |
                                <span class="fa fa-calendar"></span>&nbsp;{{article.created_at}} |
                                <span class="fa fa-eye"></span>&nbsp;{{article.view_count}}<br/>
                                <span class="fa fa-list"></span>&nbsp;<router-link :to="{name: 'searchByKeyword', params: {type: 'category', keyword: article.cslug, page: 1}  }">{{article.cname}}</router-link> |
                                <span class="fa fa-tag"></span>&nbsp;
                                <span v-if="article.tags.length>0">
                                    <span v-for="t in article.tags" :key="t.id">{{t.tag}}&nbsp;</span>
                                </span>
                                <span v-else>（没有TAG）</span>
                                <span class="fa fa-link"></span>&nbsp;<a :href="article.uri">原文链接</a> 
                            </div>
                        </h3>
                    </div>
                </div>
            </div>
        </section>
        <section class="mbr-section article content1 cid-r5nGyRy9Qs" id="content1-f">
            <div class="container">
                <div class="media-container-row">
                    <div class="m br-text col-12 col-md-12 mbr-fonts-style display-7">
                        <div style="text-align: left" v-html="article.content"></div>
                    </div>
                </div>
            </div>
        </section>
        <Footer />
    </div>
</template>

<script>
import Navigator from "@/components/Navigator";
import Footer from "@/components/Footer";
import Loading from "vue-loading-overlay";

export default {
  name: "Article",
  props: ["id"],
  components: {
    Navigator,
    Footer,
    Loading
  },
  methods: {
    getArticleById() {
      var uri = "http://api.go4pro.org/go4pro/article/byId/" + this.id;
      fetch(uri)
        .then(res => {
          return res.json();
        })
        .then(json => {
          this.article = json;
          this.isLoading = false;
          for(var i=0;i<this.article.tags.length;i++) {
              if(i==this.article.tags.length-1) {
                this.tags=this.tags+this.article.tags[i].tag;    
              } else {
                  this.tags=this.tags+this.article.tags[i].tag+",";
              }
              
          }

          console.log(this.tags);
        });
    }
  },
  created: function() {
    this.getArticleById();
  },
  data: function() {
    return {
      article: [],
      isLoading: true,
      tags: []
    };
  },
  metaInfo() {
    return {
      title: "Go4Pro.org | "+this.article.title,
      htmlAttrs: {
        lang: "zh-CN"
      },
      meta: [
        { name: "description", content: this.article.title },
        { name: "keyword", content: this.tags }
      ]
    };
  },
  watch: {
      id: function(n,o) {
          if(n!=o) {
              this.getArticleById();
          }
      }
  }
};
</script>